import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { EventCard } from '../EventCard';
import { TireTrack } from '../TireTrack';
import { getPublishedEvents } from '../../../data/events';

/**
 * Up to three events on the home page. The index page is where the full
 * programme lives; a home page that lists everything gives the reader no
 * reason to go anywhere.
 *
 * Today there is exactly one published event, so the grid collapses to a
 * single constrained card rather than stretching one card across three
 * tracks — a lone full-width card reads as a mistake. Registry D41.
 */
export function EventsPreview() {
  const featured = getPublishedEvents().slice(0, 3);
  const isSingle = featured.length === 1;
  return <section aria-labelledby="events-preview-heading" className="relative overflow-hidden bg-moss/10 py-16 sm:py-24" data-id="element-223" data-mp="5efk6myu8gy6">
      <TireTrack variant="diagonal" className="absolute -right-10 -top-10 h-[400px] w-[250px]" opacity={0.04} data-id="element-224" data-mp="1zpkgt7bibt40" />

      <div className="relative mx-auto max-w-container px-gutter-sm sm:px-gutter-md lg:px-gutter-lg" data-id="element-225" data-mp="33gyvkyzzi1n7">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-226" data-mp="38ioaipqbuzgk">
          <div className="max-w-2xl" data-id="element-227" data-mp="2tle0lktc21my">
            <p className="mb-5 border-l-4 border-moss pl-3 text-sm font-black uppercase tracking-[0.2em] text-moss" data-id="element-228" data-mp="2tmgqbpex5y1a">
              Social gatherings
            </p>
            <h2 id="events-preview-heading" className="font-bebas text-5xl leading-[0.9] tracking-wide text-ink sm:text-6xl" data-id="element-229" data-mp="3ma2rys4l6sli">
              What's on
            </h2>
            <p className="mt-4 max-w-prose text-lg leading-relaxed text-ink/80" data-id="element-230" data-mp="3cif5l5mw01qw">
              Friday is the one to know about. The car park fills up with
              bikes and the place fills up with the people who rode them,
              and there is nothing to book.
            </p>
          </div>

          <Link to="/whats-on" className="group inline-flex shrink-0 items-center gap-2 rounded-container border border-control px-5 py-3 text-sm font-bold text-ink transition-colors duration-200 ease-out-expo hover:bg-ink/5 focus:outline-none focus:ring-2 focus:ring-moss focus:ring-offset-2" data-id="element-231" data-mp="du9bgda99h4g">
            {isSingle ? "See what's on" : 'All events'}
            <ArrowRight className="h-4 w-4 transition-transform duration-200 ease-out-expo group-hover:translate-x-1 motion-reduce:transform-none" aria-hidden="true" data-id="element-232" data-mp="9onnntmc64xu" />
          </Link>
        </div>

        <ul className={`mt-12 grid gap-6 ${isSingle ? 'max-w-md' : 'sm:grid-cols-2 lg:grid-cols-3'}`} data-id="element-233" data-mp="3w2xcu4y3bgzo">
          {featured.map(event => <li key={event.id} className="flex" data-id="element-234" data-mp="3n1z63ew9ovde">
              <div className="flex-1" data-id="element-235" data-mp="3i58q0rkgpzrz">
                <EventCard event={event} data-id="element-236" data-mp="3i47g4qf6njbu" />
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}